import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import theme from 'site-react/theme';

const gridStyle = css`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${theme.spacing.lg}px ${theme.spacing.md}px;
  @media (min-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: repeat(${theme.grid.columnTotal}, 1fr);
  }
`;

const Grid = ({ children }) => <div className={gridStyle}>{children}</div>;

Grid.alignments = ['center', 'end', 'start', 'stretch'];

Grid.propTypes = {
  /*
   * One or more Grid.Item components
   */
  children: PropTypes.node.isRequired,
};

Grid.Item = ({
  align,
  children,
  colSpan,
  colStart,
  justify,
  rowSpan,
  rowStart,
}) => {
  const gridItemStyle = css`
    align-self: ${align};
    justify-self: ${justify};
    margin-bottom: ${theme.spacing.lg}px;
    min-width: 0;

    :last-child {
      margin-bottom: 0;
    }

    @supports (display: grid) {
      margin-bottom: 0;

      @media (min-width: ${theme.breakpoints.lg}px) {
        grid-column-end: ${colSpan ? `span ${colSpan}` : null};
        grid-column-start: ${colStart};
        grid-row-end: ${rowSpan ? `span ${rowSpan}` : null};
        grid-row-start: ${rowStart};
      }
    }
  `;

  return <div className={gridItemStyle}>{children}</div>;
};

Grid.Item.displayName = 'Grid.Item';

Grid.Item.defaultProps = {
  align: null,
  children: null,
  colSpan: null,
  colStart: null,
  justify: null,
  rowSpan: null,
  rowStart: null,
};

Grid.Item.propTypes = {
  /*
   * Value of the item’s `align-self` CSS property
   */
  align: PropTypes.oneOf(Grid.alignments),
  /*
   * Content to display in the item
   */
  children: PropTypes.node,
  /*
   * `span` argument of the item’s `grid-column-end` CSS property
   */
  colSpan: PropTypes.string,
  /*
   * Value of the item’s `grid-column-start` CSS property
   */
  colStart: PropTypes.string,
  /*
   * Value of the item’s `justify-self` CSS property
   */
  justify: PropTypes.oneOf(Grid.alignments),
  /*
   * `span` argument of the item’s `grid-row-end` CSS property
   */
  rowSpan: PropTypes.string,
  /*
   * Value of the item’s `grid-row-start` CSS property
   */
  rowStart: PropTypes.string,
};

export default Grid;
